var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.9999 3.0293c-.5631 0-1.1261.26244-1.4414.78711l-8.79684 14.63479c-.64823 1.078.18115 2.5488 1.43945 2.5488h17.59569c1.2579 0 2.0897-1.4708 1.4414-2.5488l-8.7969-14.63479c-.3152-.52467-.8782-.78711-1.4414-.78711zm0 2.26953 8.2364 13.70117h-16.47269zm-1 3.70117v5h2v-5zm0 7v2h2v-2z",
    fill: "currentColor"
  })));
}
export default SvgErrorreact;